module.exports = __webpack_public_path__ + "img/reading.e5edc107.svg";